var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",staticStyle:{"margin-top":"250px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('div',{staticClass:"error-template"},[_c('h1',[_vm._v("نأسف")]),_c('h2',[_vm._v("الرجاء التأكد من ادخال الرابط كاملا بشكل صحيح")]),_c('div',{staticClass:"error-actions"})])])])])
}]

export { render, staticRenderFns }